'use client';

import { useEffect } from 'react';
import { Button, Group } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { EchoengineErrorNotice } from './error-notice';
import { CONTENT_LOCALES } from '../lib/content/constants';
import { portalStrings } from '../lib/content/ui-strings';
import { ECHOENGINE } from '../lib/portal/product';

/**
 * Boundary for the whole `/echoengine` tree.
 *
 * A segment's own `error.tsx` does not catch what that segment's `layout.tsx`
 * throws, and `(protected)/layout.tsx` is where the session guard runs — so an
 * unreachable Firestore there would otherwise reach the reader as Next's stock
 * unstyled 500. This boundary sits one segment up, which is the only place that
 * can catch it.
 */
export default function EchoengineError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('echoengine failed to render:', error);
  }, [error]);

  return (
    <EchoengineErrorNotice
      digest={error.digest}
      action={
        <Group>
          <Button
            variant="light"
            color="gray"
            leftSection={<IconRefresh size={16} aria-hidden />}
            onClick={reset}
          >
            {portalStrings(CONTENT_LOCALES[0], ECHOENGINE).retry}
          </Button>
        </Group>
      }
    />
  );
}
